export default __webpack_public_path__ + "static/media/yes.cd324fc4.mp3";